import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { devices } from 'assets/styled/tokens/devices';
import tooltipArrow from 'assets/icons/blackTooltipArrow.svg';
const TooltipText = styled.span`
  visibility: hidden;
  width: ${props => props.width} !important;
  height: ${props => (props.height ? props.height : 'auto')};
  text-align: ${props => props.textAlign};
  vertical-align: middle;
  background-color: #1e1e1e !important;
  color: #fff;
  border-radius: 6px !important;
  padding: 8px;
  position: absolute;
  z-index: 10000;
  bottom: ${props => props.bottom};
  left: ${props => props.left};
  margin-left: -75px;
  font-size: ${props => props.fontSize};
  font-weight: 400;
  line-height: ${props => props.lineHeight};
  border: none !important;

  &:after {
    content: url(${tooltipArrow});
    display: inline-flex;
    position: absolute;
    top: ${props => props.afterTop};
    left: ${props => props.afterLeft};
    margin-left: -3px;
    border-width: 3px;
    width: 10px;
    overflow: hidden;
    //border-style: solid;
    //border-color: #666666 transparent transparent transparent;
  }
  @media ${devices.tabletLandscape} {
    margin-left: -137px;
    width: 291px;
  }
`;

const TooltipContainer = styled.div`
  position: relative;
  display: inline-flex;
  height: ${props => props.containerHeight};
  left: ${props => props.containerLeft};
  top: ${props => props.containerTop};
  position: absolute;
  width: 100%;
  cursor: not-allowed;
  svg {
    margin-top: auto;
    margin-bottom: auto;
    path {
      fill: white !important;
    }
  }

  :hover span {
    visibility: visible;
  }
  &.show-tooltip span {
    visibility: visible;
  }
`;

function GenericTooltip({
  text,
  className = '',
  bottom,
  left,
  afterTop,
  afterLeft,
  width,
  height,
  fontSize = '12px',
  textAlign = 'left',
  lineHeight = '14px',
  containerLeft = 'auto',
  containerTop = 'auto',
  containerHeight = '32px',
}) {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);
  // Fecha tooltip ao clicar fora
  useEffect(() => {
    const handleClickOutside = e => {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        setShowTooltip(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [text]);
  return (
    <TooltipContainer
      ref={tooltipRef}
      className={`${className} ${showTooltip ? 'show-tooltip' : ''}`}
      containerLeft={containerLeft}
      containerTop={containerTop}
      containerHeight={containerHeight}
    >
      <TooltipText
        bottom={bottom}
        left={left}
        afterLeft={afterLeft}
        afterTop={afterTop}
        width={width}
        height={height}
        fontSize={fontSize}
        textAlign={textAlign}
        lineHeight={lineHeight}
      >
        {text}
      </TooltipText>
    </TooltipContainer>
  );
}

GenericTooltip.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export { GenericTooltip };
